module.exports = __webpack_public_path__ + "assets/images/project/map-logo-bak/map-logo.jpg?v=1802d5e4";